import React from 'react';
import { Link } from 'react-router-dom';
import { usePageConfig } from '../contexts/PageConfigContext';
import './Dashboard.css';

const WIDGET_ICONS = {
  groups: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  organizations: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
      <path d="M9 22v-4h6v4" />
      <path d="M8 6h.01M16 6h.01M12 6h.01M12 10h.01M12 14h.01M16 10h.01M16 14h.01M8 10h.01M8 14h.01" />
    </svg>
  ),
  profile: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  forms: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),
  apps: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
      <line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  ),
  payments: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <line x1="2" y1="10" x2="22" y2="10" />
    </svg>
  ),
  'page-permissions': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  'group-diagram': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  'enrollment-data-manager': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="9" y="3" width="6" height="4" rx="1" />
      <rect x="5" y="10" width="5" height="4" rx="1" />
      <rect x="14" y="10" width="5" height="4" rx="1" />
      <rect x="3" y="17" width="4" height="4" rx="1" />
      <rect x="10" y="17" width="4" height="4" rx="1" />
      <rect x="17" y="17" width="4" height="4" rx="1" />
      <line x1="12" y1="7" x2="7.5" y2="10" />
      <line x1="12" y1="7" x2="16.5" y2="10" />
      <line x1="7.5" y1="14" x2="5" y2="17" />
      <line x1="7.5" y1="14" x2="12" y2="17" />
      <line x1="16.5" y1="14" x2="19" y2="17" />
    </svg>
  ),
  scheduler: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <path d="M8 14h.01M12 14h.01M16 14h.01M12 18h.01" />
    </svg>
  ),
  taxonomy: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
      <line x1="12" y1="11" x2="12" y2="17" />
      <line x1="9" y1="14" x2="15" y2="14" />
    </svg>
  ),
  'work-samples': (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  inquiries: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
      <polyline points="22 7 12 13 2 7" />
    </svg>
  )
};

const ALL_WIDGETS = [
  { id: 'groups', title: 'Groups', path: '/groups' },
  { id: 'organizations', title: 'Organizations', path: '/organizations' },
  { id: 'profile', title: 'Profile', path: '/profile' },
  { id: 'forms', title: 'Forms', path: '/forms' },
  { id: 'work-samples', title: 'Work Samples', path: '/work-samples' },
  { id: 'apps', title: 'Apps', path: '/apps' },
  { id: 'payments', title: 'Payments', path: '/payments' },
  { id: 'page-permissions', title: 'Page Permissions', path: '/page-permissions' },
  { id: 'group-diagram', title: 'Group Diagram', path: '/group-diagram' },
  { id: 'enrollment-data-manager', title: 'Enrollment Data', path: '/enrollment-data-manager' },
  { id: 'scheduler', title: 'Scheduler', path: '/scheduler' },
  { id: 'taxonomy', title: 'Taxonomy', path: '/taxonomy' },
  { id: 'inquiries', title: 'Inquiries', path: '/inquiries' }
];

const Dashboard = () => {
  const { configuration: pageConfig = {} } = usePageConfig() || {};

  const getVisibleWidgets = () => {
    if (!pageConfig || Object.keys(pageConfig).length === 0) {
      return [];
    }
    if (pageConfig.widgets && Array.isArray(pageConfig.widgets)) {
      if (pageConfig.widgets.length === 0) return [];
      return ALL_WIDGETS.filter((widget) => pageConfig.widgets.includes(widget.id));
    }
    if (pageConfig.hide && Array.isArray(pageConfig.hide)) {
      return ALL_WIDGETS.filter((widget) => !pageConfig.hide.includes(widget.id));
    }
    return [];
  };

  const visibleWidgets = getVisibleWidgets();

  return (
    <div className="dashboard-page">
      <div className="dashboard-inner">
        {visibleWidgets.length === 0 ? (
          <div className="dashboard-empty">
            <p className="dashboard-empty-text">No widgets configured for your current role.</p>
          </div>
        ) : (
          <div className="dashboard-grid" role="list">
            {visibleWidgets.map((widget) => (
              <Link
                key={widget.id}
                to={widget.path}
                className="dashboard-widget"
                role="listitem"
              >
                <div className="dashboard-widget-icon" aria-hidden>
                  {WIDGET_ICONS[widget.id]}
                </div>
                <span className="dashboard-widget-title">{widget.title}</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
